import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import {
  IFilterComponent,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { PatientSearch } from "src/app/model/patient";
import { PracticeRegionFilter } from "src/app/model/practice-region-filter";
import { ServiceFilter } from "src/app/model/service-filter";
import { SpecialityFilter } from "src/app/model/speciality-filter";
import { AdmissionService } from "src/app/services/admission.service";
import { AuthService } from "src/app/services/auth.service";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { FilterService } from "src/app/services/filter.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";

@Component({
  selector: "app-integrated-reception-admission-filter",
  templateUrl: "./integrated-reception-admission-filter.component.html",
  styleUrls: ["./integrated-reception-admission-filter.component.css"],
})
export class IntegratedReceptionAdmissionFilterComponent
  implements IFilterComponent, OnInit
{
  serviceFilters: ServiceFilter[];
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteSpecialities: FilterCompleteService<SpecialityFilter>;
  canViewOtherCenters: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private admissionService: AdmissionService,
    private authService: AuthService,
    private filterRecordService: FilterRecordService,
    private motificationToastService: NotificationToastService
  ) {
    this.serviceFilters = [];
    this.form = this.formBuilder.group({
      Date: [new Date(), [Validators.required]],
      Service: [""],
      Specialty: [""],
      PracticeRegion: [""],
      Patient: [null],
      OrderByPatient: [false],
      ViewOtherCenters: [false],
    });

    this.filterCompleteSpecialities =
      new FilterCompleteService<SpecialityFilter>(
        [],
        this.form.controls.Specialty
      );
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
      [],
      this.form.controls.Service
    );
    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        [],
        this.form.controls.PracticeRegion
      );
  }

  get filteredSpecialitiesOptions() {
    return this.filterCompleteSpecialities
      ? this.filterCompleteSpecialities.filteredOptions
      : [];
  }
  get filteredServicesOptions() {
    return this.filterCompleteServices
      ? this.filterCompleteServices.filteredOptions
      : [];
  }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion
      ? this.filterCompletePracticesRegion.filteredOptions
      : [];
  }
  get f() {
    return this.form.controls;
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push("Date");
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "IntegratedReceptionAdmissionFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "IntegratedReceptionAdmissionFilterComponent",
      this.form
    );
  }

  async search(): Promise<any> {

    if (!this.form.controls.Date.value && !this.form.controls.Patient.value) {
      this.motificationToastService.error(
        "Debe seleccionar una fecha o un paciente para realizar la busqueda.",
        "Recepción"
      );
      return [];
    } else {
      const serviceId = this.form.controls.Service.value
        ? (<ServiceFilter>this.form.controls.Service.value).Id
        : null;

      const serviceIds: number[] = [];

      if (serviceId) {
        serviceIds.push(serviceId);
      } else {
        if (!this.serviceFilters || this.serviceFilters.length === 0) {
          this.serviceFilters = await this.authService.getSectorServices();
        }
        this.serviceFilters.forEach((service) => {
          serviceIds.push(service.Id);
        });
      }

      const viewOtherCenter = this.form.controls.ViewOtherCenters.value
        ? true
        : false;

      return await this.admissionService.getAdmissionSearchItems(
        this.authService.getCompanyIds(),
        serviceIds,
        this.form.controls.OrderByPatient.value
          ? this.form.controls.OrderByPatient.value
          : false,
        this.form.controls.Date.value
          ? <Date>this.form.controls.Date.value
          : null,
        this.form.controls.Patient.value
          ? (<PatientSearch>this.form.controls.Patient.value).Id
          : null,
        this.form.controls.PracticeRegion.value
          ? (<PracticeRegionFilter>this.form.controls.PracticeRegion.value).Id
          : null,
        this.form.controls.Specialty.value
          ? (<SpecialityFilter>this.form.controls.Specialty.value).Id
          : null,
        viewOtherCenter ? null : this.authService.getCenterId(),
        viewOtherCenter ? null : this.authService.getSectorId()
      );
    }
  }

  async ngOnInit() {
    this.canViewOtherCenters = this.authService.canViewOtherCentersReception();

    const services = await this.authService.getSectorServices();
    this.serviceFilters = services;
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
      services,
      this.form.controls.Service
    );

    const practicesRegion = await this.filterService.getPracticesRegionFilter();
    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        practicesRegion,
        this.form.controls.PracticeRegion
      );

    const specialities = await this.filterService.getSpecialtiesFilter();
    this.filterCompleteSpecialities =
      new FilterCompleteService<SpecialityFilter>(
        specialities,
        this.form.controls.Specialty
      );


  }
}
